const clean = value => String(value ?? "").replace(/\s+/g, " ").trim();
export const sanctionsSubjectKey = subject => clean(subject?.key || subject?.name).toLowerCase();

// Convert only completed legacy reviews whose subject-level outcomes are known.
// A legacy manual flag without attributable hits needs an explicit subject review.
export function getSanctionsReviewState(form, subjects, matchKey) {
  const screening = form?.internalUse?.sanctionsScreening || {};
  const relevantKeys = Array.isArray(screening.relevantKeys)
    ? screening.relevantKeys
    : Array.isArray(screening.selectedKeys) ? screening.selectedKeys : [];
  if (screening.personReviews && typeof screening.personReviews === "object") {
    return { personReviews: screening.personReviews, relevantKeys };
  }
  const personReviews = {};
  const completed = screening.reviewStatus === "completed" ||
    (!screening.reviewStatus && screening.selectionSaved === true);
  if (!completed) return { personReviews, relevantKeys };
  const savedSubjects = screening.result?.subjects || screening.searchedSubjects ||
    (screening.searchedName ? [{ name: screening.searchedName }] : []);
  const screened = new Set(savedSubjects.map(sanctionsSubjectKey));
  const matches = (screening.result?.matches || []).filter(match => relevantKeys.includes(matchKey(match)));
  const manualFlag = String(form?.sanctions?.staffDecision || "").startsWith("flagged") && !matches.length;
  if (manualFlag) return { personReviews, relevantKeys };
  for (const subject of subjects) {
    const key = sanctionsSubjectKey(subject);
    if (!screened.has(key)) continue;
    const exposed = matches.some(match => {
      const name = clean(match.__subjectName || match.subjectName).toLowerCase();
      return name === key || (!name && subjects.length === 1);
    });
    personReviews[key] = { decision: exposed ? "exposure" : "no_exposure" };
  }
  return { personReviews, relevantKeys };
}

export function getSanctionsSupportingInformation(form) {
  const screening = form?.internalUse?.sanctionsScreening;
  const subjects = [
    ...(screening?.searchedSubjects || []),
    ...(screening?.result?.subjects || []),
  ];
  const notes = form?.sanctions?.supportingInformation || {};
  const seen = new Set();
  return subjects.flatMap(subject => {
    const key = sanctionsSubjectKey(subject);
    const text = typeof notes[key] === "string" ? notes[key].trim() : "";
    if (!key || seen.has(key) || !text) return [];
    seen.add(key);
    return [{ key, name: subject.name || "Screened subject", text }];
  });
}
